// To be removed after we deal with SEON issue

import { getAccountConfig } from '@accountFederation/config/accountConfig';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

export const AntifraudErrorLocation = {
    GetSession: 'AntiFraudService.getSession',
    Initialize: 'AntiFraudService.initialize',
    LoadSeonScript: 'AntiFraudService.loadSeonScript',
    SendTransaction: 'AntiFraudService.sendTransaction',
    RegisterGetSession: 'AntiFraudService.registerGetSession',
    LoginGetSession: 'AntiFraudService.loginGetSession',
    ActivateGetSession: 'AntiFraudService.activateGetSession',
} as const;
export type AntifraudErrorLocation = typeof AntifraudErrorLocation[keyof typeof AntifraudErrorLocation];

export function logAntifraudError(location: AntifraudErrorLocation, error?: string | Error): void {
    if (!getAccountConfig().isAntifraudLoggingEnabled) {
        return;
    }

    AnalyticsSDK.getInstance().log('Antifraud_Error', {
        location,
        error: error?.toString?.(),
        isScriptLoaded: !!window.seon,
    });
}
